import React, { useEffect, useState } from "react"

const TimerUI = (props) => {

    const { seconds, hideTimer } = props;
    const [timeLeft, setTimeLeft] = useState(seconds);

    useEffect(() => {
        if (!timeLeft) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
            if (timeLeft < 2) {
                hideTimer(true)
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    return (<span style={{ marginLeft: "5px" }}>{timeLeft + " sec"}</span>);
};

export default TimerUI;